export function useLocalePath() {
  const nuxtApp = useNuxtApp();
  const funnel = useFunnelContext();

  return (route: Parameters<typeof nuxtApp.$localePath>[0], locale?: Parameters<typeof nuxtApp.$localePath>[1]): string => {
    const f = funnel.value;
    const prefix = f && f !== 'baseline' ? `/${f}` : '';

    let normalizedRoute = route;
    if (prefix) {
      if (typeof route === 'string') {
        if (route.startsWith(prefix)) {
          normalizedRoute = (route.slice(prefix.length) || '/');
        }
      } else if (route !== null && typeof route === 'object' && 'path' in route) {
        const routeObj = route as { path?: string };
        if (routeObj.path?.startsWith(prefix)) {
          normalizedRoute = { ...routeObj, path: routeObj.path.slice(prefix.length) || '/' } as typeof route;
        }
      }
    }

    const path = nuxtApp.$localePath(normalizedRoute, locale);

    return (!path || !prefix || path.startsWith(prefix)) ? path : `${prefix}${path}`;
  };
}
